import React, { useState } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Modal, Button, Input, Checkbox, Select } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import TaskTypeQuantitySelect, { expandTaskTypes } from 'components/TaskTypeQuantitySelect'
import useApi from 'hooks/useApi'

export default NiceModal.create(({ order, job }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const [languages, setLanguages] = useState([])
  const [inheritPurchaseOrder, setInheritPurchaseOrder] = useState(true)
  const [customerReference, setCustomerReference] = useState('')
  const [types, setTypes] = useState([])
  const modal = useModal()

  const [languageOptions] = useApi(`/rest/v2/language`)

  const onSubmit = (event) => {
    setLoading(true)
    event?.preventDefault()

    const data = JSON.stringify({
      language: languages.map(({ innerValue }) => `${innerValue}`),
      tasktypes: expandTaskTypes(types),
      orderid: order.uid,
      jobid: job.uid,
      inheritCustomerReference: [inheritPurchaseOrder ? 'on' : 'off'],
      customerReference: inheritPurchaseOrder ? '' : customerReference.trim(),
    })

    const body = new FormData()
    body.append('data', data)

    fetch(`/ordertask/createmultipledefaultversions.json`, { method: 'POST', body })
      .then(() => {
        modal.resolve()
        modal.remove()
        setLoading(false)
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => (loading || !(!!languages?.length)) ? undefined : onSubmit()}
      title={formatMessage(messages.title)}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Select
          required
          label="Languages"
          size="xs"
          value={languages}
          onChange={setLanguages}
          options={languageOptions?.map(({ uid, name }) => ({ value: Math.random(), innerValue: uid, label: name })) }
          isMulti
          hideSelectedOptions={false}
        />

        <TaskTypeQuantitySelect
          value={types}
          onChange={setTypes}
          defaultShortnames={['VO', 'AP']}
          description="Pick a type more than once to create it multiple times per version"
        />

        <Checkbox
          onChange={() => setInheritPurchaseOrder(!inheritPurchaseOrder)}
          checked={inheritPurchaseOrder}
          label={`Inherit '${order.customerReference}' P.O. from order`}
        />

        { !inheritPurchaseOrder &&
          <Input
            optional
            label="P.O. for the new tasks"
            description="Leave empty to create the tasks without a P.O."
            size="xs"
            value={customerReference}
            onChange={(event) => setCustomerReference(event.target.value)}
          />
        }

        <Button
          type="submit"
          size="sm"
          disabled={loading || !(!!languages?.length)}
        >
          { loading ? 'Creating..' : 'Create' }
        </Button>
      </form>
    </Modal>
  )
})
